module.exports = __webpack_public_path__ + "img/defaultprofile.bc425753.png";